import { combineReducers } from "redux";
import aboutus from "../features/admin/help_section/aboutus/Slice";
import termscondition from "../features/admin/help_section/termscondition/Slice";
import privacypolicy from "../features/admin/help_section/privacypolicy/Slice";
import faq from "../features/admin/help_section/faq/Slice";
import service_terms from "../features/admin/help_section/service_terms/Slice";

const helpsection = combineReducers({
  aboutus: aboutus,
  termscondition: termscondition,
  privacypolicy: privacypolicy,
  faq: faq,
  service_terms: service_terms,
});

export default helpsection;
